import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';

// styles
import styles from './sbSharedSearchSuggestions.scss';

function SbSharedSearchSuggestionsComponent(props) {
    const { itemSearch, searchTerm } = props;
    const suggestions = get(props, 'itemSearch.searchCorrections.suggestions');

    if (itemSearch.pageType !== pageTypes.SEARCH || !suggestions || !searchTerm) {
        return null;
    }

    return (
        <ul className={props.className} data-tn="search-suggestions-wrapper">
            <li className={styles.suggestion} data-tn="search-suggestions-title">
                <FormattedMessage
                    id="sb.SbSharedSearchSuggestions.suggestionText"
                    defaultMessage="Did you mean"
                />
            </li>
            {suggestions.map(({ name, uri }) => (
                <li key={uri} className={styles.suggestion} data-tn="search-suggestion">
                    <a
                        href={uri}
                        onClick={() =>
                            trackEvent({
                                category: 'search suggestion text',
                                action: 'spelling suggestions clicked',
                                label: `${searchTerm}|${name}`,
                            })
                        }
                    >
                        <span>{name}</span>
                    </a>
                </li>
            ))}
        </ul>
    );
}

SbSharedSearchSuggestionsComponent.propTypes = {
    className: PropTypes.string,
    searchTerm: PropTypes.string,
    itemSearch: PropTypes.shape({
        pageType: PropTypes.string.isRequired,
        suggestions: PropTypes.shape({
            name: PropTypes.string.isRequired,
            uri: PropTypes.string.isRequired,
        }),
    }),
};

export const SbSharedSearchSuggestions = createFragmentContainer(
    SbSharedSearchSuggestionsComponent,
    {
        itemSearch: graphql`
            fragment SbSharedSearchSuggestions_itemSearch on ItemSearchQueryConnection {
                pageType
                searchCorrections {
                    suggestions {
                        name
                        uri
                    }
                }
            }
        `,
    }
);
